import { DimmedContent } from '@/components/CustomTravel/DimmedPopup';
import { CustomOption } from '@/components/CustomTravel/CustomInit';
import RadioField from '@/components/CustomTravel/ServiceFormFields/RadioField';
import { useFormContext } from 'react-hook-form';
import ConditionalField from '@/components/CustomTravel/ServiceFormFields/ConditionalField';
import InputTextField from '@/components/CustomTravel/ServiceFormFields/InputTextField';
import classNames from 'classnames/bind';
import styles from './SelectGroupTypeForm.module.scss';

const cx = classNames.bind(styles);

export const GroupTypeList = ({ customOptions }: { customOptions: CustomOption[] }) => {
  const ETCCODE = 'etc';
  const { setValue } = useFormContext();
  const handleOnChange = (value: any) => {
    if (value.code !== ETCCODE) {
      setValue('groupType.etcName', null, { shouldDirty: true, shouldValidate: true });
    }
  };

  return (
    <DimmedContent>
      <div className={cx('radios')}>
        {customOptions.map(({ groupType, groupDescription }) => (
          <RadioField
            key={groupType}
            className={cx('radio')}
            displayText={groupDescription}
            name="groupType.code"
            value={groupType}
            onChange={handleOnChange}
            nlogAreaCode={`cus.advgrouptype${groupType}`}
          />
        ))}
        <ConditionalField targetFieldName="groupType">
          {(value: { code: string; etcName: string }) => {
            const isEtcSelected = value?.code === ETCCODE;
            return (
              <div className={cx('etc')}>
                <InputTextField
                  disabled={!isEtcSelected}
                  type="text"
                  placeholder="직접 작성하기"
                  name="groupType.etcName"
                  maxLength={50}
                />
              </div>
            );
          }}
        </ConditionalField>
      </div>
    </DimmedContent>
  );
};
